(function () {
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-external-url]');
    if (!target || target.tagName === 'OPTION') return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = target.getAttribute('data-external-url');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var countrySelect = form.querySelector('select[name="country_code"]');
    if (!countrySelect) return;

    var option = countrySelect.options[countrySelect.selectedIndex];
    var externalUrl = option && option.getAttribute('data-external-url');
    if (!externalUrl) return;

    event.preventDefault();
    window.location.href = externalUrl;
  });
})();
